import { Check, Minus, X } from 'lucide-react';
import { LAUF_ART_LABEL, type LaufArt, type StoryTestsDto, type TestTrefferDto } from '../../lib/api/abnahme';

/**
 * Abdeckung einer Story in einer Zeile: „2/3 Kriterien · 5 Tests", farbig nach
 * dem Ergebnis der jüngsten Läufe. Grau heißt: kein Test trägt diese Story.
 */
export function TestAbdeckung({ tests }: { tests?: StoryTestsDto }) {
  if (!tests || tests.status === 'keine') {
    return <span className="text-sm text-muted-foreground">keine Tests</span>;
  }
  const farbe =
    tests.status === 'rot' ? 'text-red-600 dark:text-red-400' : 'text-emerald-700 dark:text-emerald-400';
  return (
    <span className={`text-sm ${farbe}`}>
      {tests.kriterien > 0 ? `${tests.abgedeckt}/${tests.kriterien} Kriterien · ` : ''}
      {tests.tests} {tests.tests === 1 ? 'Test' : 'Tests'}
      {tests.fehlgeschlagen > 0 ? ` · ${tests.fehlgeschlagen} rot` : ''}
    </span>
  );
}

/** Die Tests zu einem Schlüssel als kurze Liste mit Ergebnis. */
export function TestListe({ tests }: { tests?: TestTrefferDto[] }) {
  if (!tests || tests.length === 0) {
    return <p className="text-xs text-muted-foreground">Noch kein automatischer Test — von Hand prüfen.</p>;
  }
  return (
    <ul className="space-y-1">
      {tests.map((test) => (
        <li key={`${test.art}-${test.ref}`} className="flex items-start gap-1.5 text-xs">
          {test.status === 'bestanden' ? (
            <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" aria-label="grün" />
          ) : test.status === 'fehlgeschlagen' ? (
            <X className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-600" aria-label="rot" />
          ) : (
            <Minus className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-label={test.status} />
          )}
          <span className="min-w-0">
            <span className="text-muted-foreground">{LAUF_ART_LABEL[test.art as LaufArt] ?? test.art}:</span>{' '}
            <span className="break-words">{test.name}</span>
            {test.meldung && test.status === 'fehlgeschlagen' && (
              <span className="mt-0.5 block whitespace-pre-wrap break-all font-mono text-[11px] text-red-700 dark:text-red-300">
                {test.meldung.split('\n')[0]}
              </span>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}
